import AppId from "~/utils/partner";
import {
  LOGO_PNG,
  LOGO_FOOTER,
  LOGO_HEADER_COLOR,
  BANNER_HOME_DESKTOP,
  BANNER_HOME_MOBILE,
  LOGO_HEADER_WHITE,
  SLIDE,
  IMG_MA_BENH_NHAN,
  IMG_MA_THANH_TOAN
} from "~/utils/constants";

import { currentEnv } from "~/configs";
import { medproInfo, partnerInfo } from "~/configs/partnerDetails";
// import { partnerInfo } from "~/configs/partnerDetails";

import { get, find } from "lodash";

// resource-testing.medpro.com.vn/static/images/bvbnd/web/header_logo.svg

// Image
const apiurl = `${currentEnv.STATIC_CONTENT_API_URL}/static/images/${[
  AppId
]}/web`;

export const urlLogoHeader = `${apiurl}/${LOGO_HEADER_COLOR}`;
export const urlLogoHeaderWhite = `${apiurl}/${LOGO_HEADER_WHITE}`;
export const urlLogoFooter = `${apiurl}/${LOGO_FOOTER}`;
export const urlLogoInBill = `${apiurl}/${LOGO_HEADER_COLOR}`;
export const urlSlide = `${apiurl}/${SLIDE}`;
export const urlBannerHomeDesktop = `${apiurl}/${BANNER_HOME_DESKTOP}`;
export const urlBannerHomeMobile = `${apiurl}/${BANNER_HOME_MOBILE}`;
export const urlImgPatientCode = `${apiurl}/${IMG_MA_BENH_NHAN}`;
export const urlImgBillCode = `${apiurl}/${IMG_MA_THANH_TOAN}`;
export const urlLogoHeaderMedpro = `${currentEnv.STATIC_CONTENT_API_URL}/static/images/medpro/web/${LOGO_HEADER_COLOR}`;

export const getLogoInBill = partner => {
  return `${currentEnv.STATIC_CONTENT_API_URL}/static/images/${[
    partner
  ]}/web/${LOGO_HEADER_COLOR}`;
};

export const getLogoPng = partner => {
  return `${currentEnv.STATIC_CONTENT_API_URL}/static/images/${[
    partner
  ]}/web/${LOGO_PNG}`;
};

// BASIC INFO

// Info medpro
const infoMedpro = get(medproInfo, "info");
const androidMedpro = find(infoMedpro, { key: "android" }).value;
const iosMedpro = find(infoMedpro, { key: "ios" }).value;

// Info partner
const infoPartner = get(partnerInfo, "info");
const androidPartner = find(infoPartner, { key: "android" }).value;
const iosPartner = find(infoPartner, { key: "ios" }).value;

export const LINK_ANDROID_APP =
  androidPartner !== "/" ? androidPartner : androidMedpro;

export const LINK_IOS_APP = iosPartner !== "/" ? iosPartner : iosMedpro;
